import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useFetch from "../features/get";
import Header from "../../components/Header";
import { TbArrowsDownUp } from "react-icons/tb";
import { useLocation } from "react-router-dom";



function HotelList() {
 
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialGuests = Number(params.get("guests")) || 2;

  const [adults, setAdults] = useState(initialGuests);
  const [children, setChildren] = useState(0);
  const navigate=useNavigate()

  const [showFilters, setShowFilters] = useState(false);
  

  const destination = params.get("destination");
  const checkIn = params.get("checkIn");
  const checkOut = params.get("checkOut");
  const hasDates = checkIn && checkOut;
  const guests= params.get(("guests"))
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  let url = `https://api.komorotel.com/api/hotels/search?destination=${destination}`;

  if (checkIn && checkOut) {
    url += `&checkIn=${checkIn}&checkOut=${checkOut}`;
  }

  if (guests) {
    url += `&guests=${guests}`;
  }

  useEffect(() => {
    const fetchHotels = async () => {
      try {
        setLoading(true);

        const res = await fetch(url);
        const result = await res.json();

        setData(result);
      } catch (err) {
        console.error("Erreur fetch hôtels:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHotels();
  }, [url]); // 🔥 hyper important
  

  const [sortOrder, setSortOrder] = useState(null);
  const [maxPrice, setMaxPrice] = useState(50000);
  const [selectedType, setSelectedType] = useState("");

  const hotels = (data || [])
    // Filtre
      .filter((hotel) => {
        return (
          hotel.minPrice <= maxPrice &&  // ✅
          (selectedType === "" || hotel.type === selectedType)
        );
      })

      // Tri
      .sort((a, b) => {
        if (sortOrder === "asc") return a.minPrice - b.minPrice;  // ✅
        if (sortOrder === "desc") return b.minPrice - a.minPrice; // ✅
        return 0;
      });


    const handleSearch = () => {
      const guests = adults + children;

      const newParams = new URLSearchParams();

      if (destination) newParams.set("destination", destination);
      if (checkIn) newParams.set("checkIn", checkIn);
      if (checkOut) newParams.set("checkOut", checkOut);

      if (guests) newParams.set("guests", guests);

      // 👉 navigation = update URL → relance fetch
      navigate(`/hotels?${newParams.toString()}`);
    };
    const queryParams = new URLSearchParams();

    if (checkIn) queryParams.set("checkIn", checkIn);
    if (checkOut) queryParams.set("checkOut", checkOut);

    const queryString = queryParams.toString();

  return (
    <>
      <Header />
      {!loading && hotels.length === 0 ? (

      <div className="flex flex-col items-center justify-center mt-28 text-center">

        <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center text-2xl mb-4">
          😕
        </div>

        <h2 className="text-xl font-semibold text-gray-900">
          {hasDates
            ? "Aucun hôtel disponible"
            : "Aucun résultat trouvé"}
        </h2>

        <p className="text-gray-500 mt-2 max-w-md">
          {hasDates
            ? "Aucun hébergement n’est disponible pour ces dates. Essayez de modifier vos dates."
            : "Aucun hébergement ne correspond à vos filtres. Essayez de les modifier."}
        </p>

        <div className="mt-6 flex gap-3">

          {!hasDates ? (
            <button
              onClick={() => {
                setMaxPrice(1000);
                setSelectedType("");
              }}
              className="px-4 py-2 rounded-lg text-sm bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
            >
              Réinitialiser les filtres
            </button>
          ) : (
            <button
              onClick={() => navigate('/')}
              className="px-4 py-2 rounded-lg text-sm bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
            >
              Modifier ma recherche
            </button>
          )}

    
        </div>

      </div>
    ):(

      <div className="min-h-screen bg-gray-50 pt-28 px-4">

        <div className="max-w-7xl mx-auto flex gap-8">

          {/* SIDEBAR */}
          <div className="hidden lg:block w-[260px]">
            <div className="bg-white p-5 rounded-2xl shadow-sm sticky top-28">

              <h2 className="text-lg font-semibold mb-4">Filtres</h2>

              {/* 💰 Prix */}
              <div className="mb-6">
                <p className="text-sm font-medium mb-2">Prix max</p>

                <input
                  type="range"
                  min="50"
                  max="1000"
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(e.target.value)}
                  className="w-full"
                />

                <p className="text-sm text-gray-500 mt-1">
                  Jusqu'à {maxPrice}€
                </p>
              </div>

              {/* 🏠 Type */}
              <div className="mb-6">
                <p className="text-sm font-medium mb-2">Type</p>

                <div className="flex flex-col gap-2 text-sm">
                  <label><input type="radio" name="type" onChange={() => setSelectedType("")}/> Tous</label>
                  <label><input type="radio" name="type" onChange={() => setSelectedType("hotel")}/> Hôtel</label>
                  <label><input type="radio" name="type" onChange={() => setSelectedType("appartement_studio")}/> Appartement&Studio</label>
                  <label><input type="radio" name="type" onChange={() => setSelectedType("chambre_hote")}/> Chambre d’hôte</label>
                </div>
              </div>

              {/* 👥 Voyageurs */}
              <div className="mb-4">
                <p className="text-sm font-medium mb-3">Voyageurs</p>

                <div className="flex flex-col gap-3 text-sm">

                  {/* Adultes */}
                  <div className="flex justify-between items-center">
                    <span>Adultes</span>
                    <div className="flex items-center gap-2">
                      <button onClick={() => setAdults(Math.max(1, adults - 1))} className="px-2 py-1 bg-gray-200 rounded">-</button>
                      <span>{adults}</span>
                      <button onClick={() => setAdults(adults + 1)} className="px-2 py-1 bg-gray-200 rounded">+</button>
                    </div>
                  </div>

                  {/* Enfants */}
                  <div className="flex justify-between items-center">
                    <span>Enfants</span>
                    <div className="flex items-center gap-2">
                      <button onClick={() => setChildren(Math.max(0, children - 1))} className="px-2 py-1 bg-gray-200 rounded">-</button>
                      <span>{children}</span>
                      <button onClick={() => setChildren(children + 1)} className="px-2 py-1 bg-gray-200 rounded">+</button>
                    </div>
                  </div>

                </div>

                {/* résumé */}
                <p className="text-xs text-gray-500 mt-2">
                  {adults} adultes • {children} enfants
                </p>
              </div>

              {/* 🔘 Bouton */}
              <button
                onClick={handleSearch}
                className="w-full bg-[#3A9D23] hover:bg-[#3A9D23] text-white py-2 rounded-xl font-medium transition"
              >
                Rechercher
              </button>

            </div>
          </div>

          {/* MAIN CONTENT */}
          <div className="flex-1">

            {/* Title + sort */}
            <div className="mb-8 flex items-center justify-between">
              <div className="flex flex-col mb-4">

                <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 leading-tight">
                  Hôtels à{" "}
                  <span className="text-[#3A9D23] break-words">
                    {destination || "Toutes les destinations"}
                  </span>
                </h1>

                <p className="text-xs sm:text-sm text-gray-500 mt-1">
                  Découvrez les meilleurs hébergements disponibles
                </p>

              </div>

                <div className="hidden lg:flex items-center gap-2 px-3 py-2 bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition">

                  <TbArrowsDownUp className="text-gray-500" />

                  <select
                    value={sortOrder || ""}
                    onChange={(e) => setSortOrder(e.target.value)}
                    className="
                      appearance-none bg-transparent
                      outline-none text-gray-700 text-sm font-medium cursor-pointer
                    "
                  >
                    <option value="">Trier</option>
                    <option value="asc">Prix croissant</option>
                    <option value="desc">Prix décroissant</option>
                  </select>

                </div>
                <div className="lg:hidden flex items-center justify-between mb-4">


  

                <div className="flex items-center gap-3">

                  {/* TRI (compact) */}
                  <div className="flex items-center gap-1 text-sm text-gray-700">
                    <TbArrowsDownUp className="text-gray-400" />

                    <select
                      value={sortOrder || ""}
                      onChange={(e) => setSortOrder(e.target.value)}
                      className="bg-transparent outline-none text-sm font-medium max-w-[110px]"
                    >
                      <option value="">Trier</option>
                      <option value="asc">Prix ↑</option>
                      <option value="desc">Prix ↓</option>
                    </select>
                  </div>

                  {/* FILTRES (compact premium) */}
                  <button
                    onClick={() => setShowFilters(true)}
                    className="
                      relative px-3 py-1.5
                      bg-white border border-gray-200
                      rounded-lg
                      text-sm font-medium text-gray-800
                      shadow-sm
                      active:scale-[0.98]
                    "
                  >
                    {(selectedType || maxPrice < 1000) && (
                      <span className="absolute -top-1 -right-1 w-2 h-2 bg-[#3A9D23] rounded-full" />
                    )}

                    Filtres
                  </button>

                </div>


                {showFilters && (
                <div className="fixed inset-0 z-50 flex items-end">

                  {/* Overlay */}
                  <div
                    className="absolute inset-0 bg-black/40"
                    onClick={() => setShowFilters(false)}
                  />

                  {/* Sheet */}
                  <div className="relative w-full bg-white rounded-t-3xl p-5 max-h-[85vh] overflow-y-auto animate-slideUp">

                    {/* Handle (petite barre en haut) */}
                    <div className="w-10 h-1.5 bg-gray-300 rounded-full mx-auto mb-4" />

                    <h2 className="text-lg font-semibold mb-4">Filtres</h2>

                    {/* 💰 Prix */}
                    <div className="mb-6">
                      <p className="text-sm font-medium mb-2">Prix max</p>

                      <input
                        type="range"
                        min="50"
                        max="1000"
                        value={maxPrice}
                        onChange={(e) => setMaxPrice(e.target.value)}
                        className="w-full"
                      />

                      <p className="text-sm text-gray-500 mt-1">
                        Jusqu'à {maxPrice}€
                      </p>
                    </div>

                    {/* 🏠 Type */}
                    <div className="mb-6">
                      <p className="text-sm font-medium mb-2">Type</p>

                      <div className="flex flex-col gap-2 text-sm">
                        <label><input type="radio" name="type" onChange={() => setSelectedType("")}/> Tous</label>
                        <label><input type="radio" name="type" onChange={() => setSelectedType("hotel")}/> Hôtel</label>
                        <label><input type="radio" name="type" onChange={() => setSelectedType("appartement_studio")}/> Appartement&Studio</label>
                        <label><input type="radio" name="type" onChange={() => setSelectedType("chambre_hote")}/> Chambre d’hôte</label>
                      </div>
                    </div>

                    {/* 👥 Voyageurs */}
                    <div className="mb-4">
                      <p className="text-sm font-medium mb-3">Voyageurs</p>

                      <div className="flex flex-col gap-3 text-sm">

                        {/* Adultes */}
                        <div className="flex justify-between items-center">
                          <span>Adultes</span>
                          <div className="flex items-center gap-2">
                            <button onClick={() => setAdults(Math.max(1, adults - 1))} className="px-2 py-1 bg-gray-200 rounded">-</button>
                            <span>{adults}</span>
                            <button onClick={() => setAdults(adults + 1)} className="px-2 py-1 bg-gray-200 rounded">+</button>
                          </div>
                        </div>

                        {/* Enfants */}
                        <div className="flex justify-between items-center">
                          <span>Enfants</span>
                          <div className="flex items-center gap-2">
                            <button onClick={() => setChildren(Math.max(0, children - 1))} className="px-2 py-1 bg-gray-200 rounded">-</button>
                            <span>{children}</span>
                            <button onClick={() => setChildren(children + 1)} className="px-2 py-1 bg-gray-200 rounded">+</button>
                          </div>
                        </div>

                      </div>

                      {/* résumé */}
                      <p className="text-xs text-gray-500 mt-2">
                        {adults} adultes • {children} enfants
                      </p>
                    </div>

                    {/* CTA */}
                    <button
                      onClick={() => {setShowFilters(false); handleSearch()}}
                      className="w-full mt-6 bg-[#3A9D23] text-white py-3 rounded-xl font-medium"
                    >
                      Voir les résultats
                    </button>

                  </div>
                </div>
              )}

              </div>
            </div>

            {/* GRID */}
            <div className="grid sm:grid-cols-2 xl:grid-cols-2 gap-8">
              {loading
                ? [...Array(6)].map((_, i) => (
                    <div
                      key={i}
                      className="h-[300px] bg-gray-200 rounded-2xl animate-pulse"
                    />
                  ))
                : hotels.map((hotel) => (
                  
                    <a
                      key={hotel._id}
                      href={`/hotel/slug/${hotel.slug}${queryString ? `?${queryString}` : ""}`}
                      className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition duration-300 hover:-translate-y-1"
                    >
                      {/* Image */}
                      <div className="h-[200px] overflow-hidden">
                        <img
                          src={hotel.photos[0]}
                          alt={hotel.name}
                          className="w-full h-full object-cover transition duration-500 group-hover:scale-105"
                        />
                      </div>

                      {/* Content */}
                      <div className="p-4">
                        <h3 className="text-lg font-semibold tracking-tight text-gray-900">
                          {hotel.name}
                        </h3>

                        <p className="text-sm text-gray-500 mt-1">
                          {hotel.type === "hotel" && "Hôtel"}
                          {hotel.type === "chambre_hote" && "Chambre d'hôte"}
                          {hotel.type === "appartement_studio"&& "Appartement&Studio"}
                        </p>

                        <p className="text-sm text-gray-600 mt-2 line-clamp-2">
                          {hotel.desc}
                        </p>

                        <div className="flex items-center justify-between mt-4">
                          <span className="text-base font-semibold text-gray-900">
                            {hotel.minPrice ? `À partir de ${hotel.minPrice}€` : "Prix non disponible"}
                          </span>
                          <span className="text-sm text-gray-500">
                            / nuit
                          </span>
                        </div>
                      </div>
                    </a>
                  ))}
            </div>

          </div>
        </div>
      </div>
    )}   
    </>
  );
}

export default HotelList;